import { addDays, isAfter, isValid, parseISO } from "date-fns";

/**
 * Mirrors Powerapp::RETENTION_DAYS. Keep the two in step.
 */
export const RETENTION_DAYS = 90;

/**
 * Whether an application is past the retention window, in which case the server
 * withholds its PII and RefuseExpiredApplication rejects every write endpoint
 * behind the row's actions — duplicate, copy, add note, resend signature, send
 * to service, edit pricing and equipment, the VAR sheet, the OTP email and
 * mobile. Offering those actions leaves the user on a 403 the modals do not
 * report, so the menus are hidden instead.
 *
 * Takes the row rather than a date: the detail and Elasticsearch payloads carry
 * `retention_expired` from Powerapp::withholdPii, but rows withheld as models
 * (getPreapp) deliberately carry no flag — setting one would dirty the model —
 * so created_at is the fallback and every list row has it.
 *
 * The server's Carbon check truncates to whole days, so it keeps accepting
 * writes for up to a day after this returns true. Erring that way is
 * deliberate: hiding an action a moment early costs nothing, showing one that
 * cannot succeed is the bug this fixes.
 */
export const isAppRetentionExpired = (app) => {
  if (app == null) return false;
  if (app.retention_expired === true) return true;

  const createdAt = app.created_at;
  if (createdAt == null) return false;

  const created = createdAt instanceof Date ? createdAt : parseISO(createdAt);
  if (!isValid(created)) return false;

  return isAfter(new Date(), addDays(created, RETENTION_DAYS));
};
